import initial from '@/pages/inventory/active/import/initial/routes';
import quash from '@/pages/inventory/active/import/quash/routes';
import reception from '@/pages/inventory/active/import/reception/routes';

export default [initial, reception, quash];
